import {observer_mgl} from "mobx-graphlink";
import React, {useState} from "react";
import {ShowVMenu, VMenuItem} from "react-vmenu";
import {TextPlus} from "web-vcore";
import {Vec2} from "../../Utils/ThreeJS/VectorStructs.js";
import {liveSkin} from "../../Utils/Styles/StyleManager.js";

export type FieldLabelProps = {
	/** The field path that will be copied when the user clicks "Copy field path" */
	fieldPath: string;
	/** The text to display (label) */
	text: string;
	/** Optional info tooltip text */
	info?: string;
	/** Additional styles to apply to the label */
	style?: React.CSSProperties;
} & React.ComponentPropsWithoutRef<typeof TextPlus>;

export const flp = "2px 4px";
export const FieldLabel = (props: FieldLabelProps)=>{
	const {fieldPath, text, info, style, ...rest} = props;
	const [isHovered, setIsHovered] = useState(false);

	const handleClick = (e: React.MouseEvent)=>{
		const buttonRect = (e.target as HTMLElement).getBoundingClientRect();
		ShowVMenu(
			{pos: new Vec2(buttonRect.left, buttonRect.top + buttonRect.height)},
			<>
				<VMenuItem text="Copy field path" style={liveSkin.Style_VMenuItem()} onClick={()=>{
					navigator.clipboard.writeText(fieldPath);
				}}/>
			</>,
		);
	};

	return (
		<TextPlus {...rest}
			info={info}
			style={{
				...style,
				backgroundColor: isHovered ? "rgba(100, 150, 200, 0.3)" : "transparent",
				padding: flp,
				borderRadius: 3,
				cursor: "pointer",
				transition: "background-color 0.2s ease",
			}}
			infoProps={{style: {marginLeft: 1}} as any}
			onMouseEnter={()=>setIsHovered(true)}
			onMouseLeave={()=>setIsHovered(false)}
			onClick={handleClick}
		>
			{text}
		</TextPlus>
	);
};